import { Component, ViewEncapsulation, OnInit, Input, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { RateManagerService } from '@app/_components/rate/rate-manager';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { CalendarModule } from 'primeng/calendar';
import * as moment from 'moment';
import { LazyLoadEvent, MessageService, MenuItem, TreeNode } from 'primeng/api';
import { Table } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { MatDialogConfig, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RateSeasonComponent } from '../rate-season/rate-season.component';
// import { RateLosComponent } from '../rate-los/rate-los.component';
import { RateSeasonSummaryService } from './rate-season-summary.service';
import { TapeChartService } from '../../tape-chart';
import { PropertyConfigComponent } from '../../property-config/property-config.component';

@Component({
    selector: 'app-rate-season-summary',
    templateUrl: './rate-season-summary.component.html',
    styleUrls: ['./rate-season-summary.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RateSeasonSummaryComponent implements OnInit
{
  @Input() propertyId: any;
  @Input() propertyCode: any;
  @ViewChild('dt') dt: Table;
  // data
  advertisedRates: any = [];
  advertisedRateRows: any = [];
  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAction: String;
  formLabels = [];
  formReadOnly = false;
  position = "top";
  seasonNotes: any;
  showNoteWindow = false;
  currentRateBucketDetailId: any;


  // to hold the current search
  currentSearchForm: any;
  // p-table
  first = 0;
  rows = 50;
  datasource;
  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];
  scrollingColumns: any[] = [];
  frozenColumns: any[] = [];
  frozenWidth: string = '400px';
  dayMs = 1000 * 3600 * 24;

  // window
  innerWidth;
  innerHeight;
  items: MenuItem[] | undefined;
  selectedNode: any;
  sortingState: { [key: string]: 'asc' | 'desc' } = {};
  sortingColDate = null;
  selectedSortField: string = 'occPct'; // Default selection

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private rateSeasonSummaryService: RateSeasonSummaryService,
    private rateManagerService: RateManagerService,
    private tapeChartService: TapeChartService,
    private alertService: AlertService,
    public messageService: MessageService,
    private location: Location,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef) { }


  ngOnInit(): void
  {
    this.setInnerWidthHeightParameters();
    this.items = [
      {
          label: 'YieldMax Actions',
          items: [
              {
                  label: 'Tape Chart',
                  icon: 'pi pi-calendar-times',
                  command: (event) => this.redirectToProperty(this.selectedNode, 3)
              },
              {
                  label: 'Reservation',
                  icon: 'pi pi-check-square',
                  command: (event) => this.redirectToProperty(this.selectedNode, 1)
              },
              {
                label: 'Season',
                icon: 'pi pi-pencil',
                command: (event) => this.onOpenRateBucketDetailEdit(this.selectedNode.rateBucketDetailId, 0, event)
              },
              {
                label: 'Season History',
                icon: 'pi pi-history',   // history-looking icon
                command: (event) => this.onOpenRateBucketDetailEdit(this.selectedNode.rateBucketDetailId, 1, event)
              },
              {
                label: 'Note',
                icon: 'pi pi-pencil',
                command: (event) => this.viewNotes(this.selectedNode.rateBucketDetailId)
              }
          ]
      },
      {
        label: 'Wiki Actions',
        items: [
            {
                label: 'Tape Chart',
                icon: 'pi pi-calendar-times',
                command: (event) => this.redirectToWikiTapeChart(this.selectedNode)
            },
            {
                label: 'Reservation',
                icon: 'pi pi-check-square',
                command: (event) => this.redirectToWikiReservation(this.selectedNode)
            },
            {
                label: 'Property',
                icon: 'pi pi-pencil',
                command: (event) => this.redirectToWikiProperty(this.selectedNode)
            },
            {
              label: 'Public Web Page',
              icon: 'pi pi-pencil',
              command: (event) => this.redirectToPublicSite(this.selectedNode)
            }
        ]
    }
  ];
  }

   /**
   * Redirect to Property page on YM filtered by current dialog property
   * @param opsNoteDetail 
   * @param defaultTabIndx 
   */
   redirectToProperty(opsNoteDetail:any, defaultTabIndx: any)
   {
   let baseUrl = '/property-config/'+opsNoteDetail.propertyId;
   if(opsNoteDetail.rateBucketId)
   {
     baseUrl = baseUrl + '/' + opsNoteDetail.rateBucketId;
   }
   
   baseUrl = baseUrl + '/' + defaultTabIndx;

   if(opsNoteDetail.startDate != null)
    {
      baseUrl = baseUrl + '/'+opsNoteDetail.startDate;
    }
    if(opsNoteDetail.endDate != null)
    {
      baseUrl = baseUrl + '/'+opsNoteDetail.endDate;
    }
   
   const url = this.router.serializeUrl(
     this.router.createUrlTree([baseUrl])
     );
     window.open(url, '_blank');
   }

   /**
   * Redirect to Wiki tape chart
   * @param opsNoteDetail 
   * @param defaultTabIndx 
   */
   redirectToWikiTapeChart(seasonSummaryDetail:any)
   {
   let baseUrl = '/tapechart';
    if(seasonSummaryDetail.extSystemId != null)
    {
      baseUrl = baseUrl + '/'+seasonSummaryDetail.extSystemId;
    }
    if(seasonSummaryDetail.startDate != null)
    {
      baseUrl = baseUrl + '/'+seasonSummaryDetail.startDate;
    }
    if(seasonSummaryDetail.endDate != null)
    {
      baseUrl = baseUrl + '/'+seasonSummaryDetail.endDate;
    }
    if(seasonSummaryDetail.minStayExpected != null)
    {
      baseUrl = baseUrl + '/'+Math.ceil(seasonSummaryDetail.minStayExpected);
    }
  
   const url = this.router.serializeUrl(
     this.router.createUrlTree([baseUrl])
     );
     window.open(url, '_blank');
   }

     /**
   * Redirect to Wiki reservation
   * @param opsNoteDetail 
   * @param defaultTabIndx 
   */
     redirectToWikiReservation(seasonSummaryDetail:any)
     {
     let baseUrl = '/reservations/property/'+seasonSummaryDetail.propertyCode;
    
     const url = this.router.serializeUrl(
       this.router.createUrlTree([baseUrl])
       );
       window.open(url, '_blank');
     }

   /**
   * Redirect to Property page on YM filtered by current dialog property
   * @param opsNoteDetail 
   * @param defaultTabIndx 
   */
   redirectToWikiProperty(seasonSummaryDetail:any)
   {
    let baseUrl = '/property-list';
    if(seasonSummaryDetail.extSystemId != null)
    {
      baseUrl = '/property-edit/'+seasonSummaryDetail.extSystemId;
    }
      const url = this.router.serializeUrl(
      this.router.createUrlTree([baseUrl])
      );
      window.open(url, '_blank');
   }

   /**
   * Redirect to Public website
   */
   redirectToPublicSite(seasonSummaryDetail:any)
   {
    let baseUrl = 'https://www.kbmresorts.com/vacation-rentals';
    if(seasonSummaryDetail.extSystemId != null)
    {
      baseUrl = baseUrl + '/' + seasonSummaryDetail.extSystemId;
    }
    window.open(baseUrl, '_blank');
   }

   viewNotes(rateBucketDetailId)
   {
    this.showNoteWindow = false; // Close the dialog first (optional)
    
    this.currentRateBucketDetailId = null; // Clear the ID

    setTimeout(() => {
        this.currentRateBucketDetailId = rateBucketDetailId;
        this.showNoteWindow = true;
        this.cdr.markForCheck();
    }, 50);
   }

  getAdvertisedRatesByStrId(propertyId)
  {
    try
    {
      this.formLoading = true;
      this.rateManagerService.getAdvertisedRatesByShortTermRentalId(propertyId)
        .subscribe(
          res =>
          {
            // console.log('getAdvertisedRates SUCCESS: ' + JSON.stringify(res.data.advertisedRates));
            return res.data.advertisedRates;
          },
          err =>
          {
            console.log('getAdvertisedRates FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.alertService.error(error);
    }
  }

  generateRates()
  {
	try
	  {
	  this.loading = true;
	  this.tapeChartService.generateRates()
		.subscribe(
		res =>
		{
			this.loading = false;
			this.cdr.markForCheck();
		},
		err =>
		{
			console.log('generateRates FAIL: ' + JSON.stringify(err));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
			this.cdr.markForCheck();
		},
		() => { this.loading = false; this.cdr.markForCheck(); });

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being generated, please check back shortly for results.', life: 3000 });
		this.loading = false;

	} catch (error)
	{
		this.loading = false;
		this.alertService.error(error);
	}
  }

  getRatesForNewSearch(searchForm)
  {
    try
    {
      this.formLoading = true;
      this.cdr.markForCheck();
      this.rateSeasonSummaryService.searchRateSummaries(searchForm)
        .subscribe(
          res =>
          {
            // console.log('searchRateSummaries SUCCESS: ' + JSON.stringify(res.data.rateSummary));
            this.advertisedRates = res.data.rateSummary;
            this.buildColumns();
            this.buildRows();
            // detectChanges() forces a synchronous CD run so all rows render at once
            // (markForCheck() only schedules a future check, causing rows to appear
            // incrementally as the user clicks around — the OnPush rendering bug)
            this.cdr.detectChanges();
            // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 1000 });
          },
          err =>
          {
            console.log('searchRateSummaries FAIL: ' + JSON.stringify(err));
            this.formLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
            this.cdr.markForCheck();
          },
          () => { this.formLoading = false; this.cdr.detectChanges(); });

    } catch (error)
    {
      this.alertService.error(error);
    }
  }


  getAdvertisedRatesToSpliceIntoResult(searchForm, selectedPropertyCodes: any)
  {
    try
    {
      this.formLoading = true;
      this.rateManagerService.getAdvertisedRates(searchForm)
        .subscribe(
          res =>
          {
            // console.log('getAdvertisedRates SUCCESS: ' + JSON.stringify(res.data.advertisedRates));
            let updatedAdvertisedRates = res.data.advertisedRates;
            this.spliceRows(updatedAdvertisedRates);
            this.messageService.add({ sticky: true, key: 'r', severity: 'success', summary: 'Success', detail: 'Updated the following properties with the new settings: <br><br>' + selectedPropertyCodes });
            this.cdr.markForCheck();
          },
          err =>
          {
            console.log('getAdvertisedRates FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
            this.cdr.markForCheck();
          },
          () => { this.formLoading = false; this.cdr.markForCheck(); });

    } catch (error)
    {
      this.alertService.error(error);
    }
  }


  spliceRows(updatedAdvertisedRates)
  {

    for (let e = 0; e < updatedAdvertisedRates.length; e++)
    {
      // clear between queries
      let rateRow: any = {};

      // for each advertisedRate row in the updated advertisedRate list
      for (let index = 0; index < updatedAdvertisedRates[e].length; index++)
      {
        rateRow[index] = updatedAdvertisedRates[e][index];
      }
      rateRow.rateBucketName = updatedAdvertisedRates[e][0].rateBucketName;
      rateRow.bedrooms = updatedAdvertisedRates[e][0].bedrooms;
      rateRow.annualRevTargetAmnt = updatedAdvertisedRates[e][0].annualRevTargetAmnt;
      rateRow.adrDevelopmentName = updatedAdvertisedRates[e][0].adrDevelopmentName;
      rateRow.propertyCode = updatedAdvertisedRates[e][0].propertyCode;

      // splice into existing array
      let itemIndex = this.advertisedRateRows.findIndex(advertisedRate => advertisedRate[0].propertyId === updatedAdvertisedRates[e][0].propertyId);
      this.advertisedRateRows[itemIndex] = rateRow;

      // use the dots so it updates when sorted https://github.com/primefaces/primeng/issues/2219
      this.advertisedRateRows = [... this.advertisedRateRows];

    }
  }

  toggleSort(sortingColDate: string) {

    this.sortingState = { [sortingColDate]: this.sortingState[sortingColDate] === 'asc' ? 'desc' : 'asc' };

    // Toggle between 'asc', 'desc', and reset
    this.sortingColDate = sortingColDate;

    // Prepare sorting parameters for API request
    const sortOrder = this.sortingState[sortingColDate];
    console.log(sortingColDate)
    console.log(sortOrder)
    if (sortOrder) {
      let searchForm = { ...this.currentSearchForm };
      searchForm['sortSeasongByStartDate'] = sortingColDate;
      searchForm['sortSeasonByOrder'] = sortOrder;
      searchForm['sortSeasonByField'] = this.selectedSortField;
      this.onSearchSubmit(searchForm)
    }
  }

  onSortFieldChange(newValue: string) {
    if(this.sortingColDate != null && this.sortingColDate != '')
    {
      this.onSearchSubmit(this.currentSearchForm);
    }
}

  buildColumns()
  {

    // clear between queries
    this.scrollingColumns = [];
    this.frozenColumns = [];

    const cols = this.innerWidth < 768 ? [
      { field: 'propertyCode', header: 'Property' },
      { field: 'rateBucketName', header: 'Bucket' }
    ] : this.innerWidth < 992 ? [
      { field: 'propertyCode', header: 'Property' },
      { field: 'rateBucketName', header: 'Bucket' },
      { field: 'bedrooms', header: 'Beds' }
    ] : [
      { field: 'propertyCode', header: 'Property' },
      { field: 'rateBucketName', header: 'Bucket' },
      { field: 'bedrooms', header: 'Beds' },
      { field: 'annualRevTargetAmnt', header: 'Target' },
      { field: 'rateBucketAdjusterPct', header: 'Rate Adj' }
    ];
    // Pre-compute left offsets so the template uses CSS sticky instead of pFrozenColumn directive.
    // pFrozenColumn runs updateStickyPosition() in ngAfterViewChecked on every CD cycle — one DOM
    // reflow per cell. With 500+ frozen cells this was the main source of freeze/jank.
    this.frozenColumns = cols.map((col, i) => ({ ...col, left: (i * 75) + 'px' }));

    // unfrozen scrollingColumns - use the first property returned
    for (let index = 0; index < this.advertisedRates[0]?.length; index++)
    {

      let startDate: Date = new Date(this.advertisedRates[0][index].startDate);
      let endDate: Date = new Date(this.advertisedRates[0][index].endDate);

      const seasonData = this.advertisedRates[0][index];
      const descParts: string[] = [];
      if (seasonData.description) { descParts.push(seasonData.description); }
      if (seasonData.publicRateDesc) { descParts.push(seasonData.publicRateDesc); }
      this.scrollingColumns.push({
        field: index, startDate: startDate, header: new DatePipe('en-US').transform(seasonData.startDate, 'MM-dd-yy')
          + ' ' + (1 + (endDate.getTime() - startDate.getTime()) / this.dayMs) + 'd '
          + ' ' + seasonData.name,
        description: descParts.length > 0 ? descParts.join(' | ') : null,
        width: '70px'
      });
    }
  }

  buildRows()
  {
    // clear between queries
    this.advertisedRateRows = [];
    for (let e = 0; e < this.advertisedRates.length; e++)
    {


      // clear between queries
      let rateRow: any = {};

      // for each advertisedRate row in the advertisedRate list
      for (let index = 0; index < this.advertisedRates[e].length; index++)
      {
        rateRow[index] = this.advertisedRates[e][index];
      }

      if (this.advertisedRates[e][0]) {
        rateRow.rateBucketName = this.advertisedRates[e][0].rateBucketName;
        rateRow.bedrooms = this.advertisedRates[e][0].bedrooms;
        rateRow.annualRevTargetAmnt = this.advertisedRates[e][0].annualRevTargetAmnt;
        rateRow.adrDevelopmentName = this.advertisedRates[e][0].adrDevelopmentName;
        rateRow.propertyCode = this.advertisedRates[e][0].propertyCode;
        rateRow.rateBucketAdjusterPct = this.advertisedRates[e][0].rateBucketAdjusterPct;
      }

      this.advertisedRateRows.push(rateRow);
    }
  }



  getPriceFontColor(advertisedRate: any)
  {
    if (advertisedRate)
    {
      if (advertisedRate.activeRate > advertisedRate.defaultRate)
      {
        return 'red';
      }
      if (advertisedRate.activeRate < advertisedRate.defaultRate)
      {
        return 'green';
      }
      else
      {
        return 'black';
      }
    }
  }

  getOccupiedBackgroundColor(advertisedRate: any, fieldName: any)
  {
    if (advertisedRate && fieldName !== 'rateBucketName' && fieldName !== 'adrDevelopmentName' && fieldName !== 'bedrooms' && fieldName !== 'annualRevTargetAmnt' && fieldName !== 'adrDevelopmentName' && fieldName !== 'propertyCode')
    {
      if (advertisedRate.availability === 1)
      {
        return '#ddfada';
      }
      else
      {
        return 'none';
      }
    }
  }

  getSeasonColor(advertisedRate: any, fieldName: any)
  {
    if (advertisedRate && fieldName !== 'rateBucketName' && fieldName !== 'adrDevelopmentName' && fieldName !== 'bedrooms' && fieldName !== 'annualRevTargetAmnt' && fieldName !== 'adrDevelopmentName' && fieldName !== 'propertyCode')
    {
      if (advertisedRate.rateSeasonEnd === advertisedRate.analyzedDate)
      {
        return '1px solid blue';
      }
      else
      {
        return 'none';
      }
    }
    else
    {
      return 'none';
    }
  }


  /*********
       * onOpenRateBucketDetailEdit
       *
       */
  onOpenRateBucketDetailEdit(rateSeasonId: number, tabIndex: number, event: any)
  {
    // if we don't stop propagation, getSeason(), getOccupiedBackgroundColor() and getPriceFontColor() called which causes massive delay.
    if(event.stopPropagation)
    {
      event.stopPropagation();
    }
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    // Size: this dialog has two 6-col columns + 26 sliders so it needs generous width.
    // No height cap — let content scroll naturally inside mat-dialog-content.
    dialogConfig.maxWidth = '100vw';
    dialogConfig.width = '92vw';

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      rateSeasonId: rateSeasonId,
      title: 'Edit RateSeason',
      formAction: 'edit',
      selectedTabIndex: tabIndex
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(RateSeasonComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data =>
      {
        // console.log('Dialog output:', data);

        // update the other rows with the same rateDetailId after we make an edit to anyone with that rateDetailId
        // this.updateRowsWithSameRateDetailId(rateBucketDetailId);

        // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Profile.', life: 7000 });
        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.updateRateBucketDetailCB(data);

        this.messageService.add({ severity: 'success', summary: 'Updated', detail: data.message });

        // close the dialogBox
        dialogRef.close();
      });

    dialogRef.componentInstance.doDelete.subscribe(
      data =>
      {
        // console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        //  this.deleteRateBucketDetailCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }


  /*********
         * Edit Button
         *
         */
  onOpenLosView(propertyId: number, analyzedDate: Date, event: Event)
  {
    // if we don't stop propagation, getSeason(), getOccupiedBackgroundColor() and getPriceFontColor() called which causes massive delay.
    event.stopPropagation();

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    // console.log('LOS: ', analyzedDate + ' ' + propertyId);


    let endDate = new Date(analyzedDate);
    endDate.setDate(endDate.getDate() + 10);

    dialogConfig.data = {
      startDate: analyzedDate,
      endDate: endDate,
      propertyId: propertyId,
      title: 'LOS View',
      formAction: 'view',
      width: '100%',
      minWidth: '100%',
      height: '100%',
      minHeight: '100%',

    };
    // console.log('LOS: ', dialogConfig.data + ' ' + JSON.stringify(dialogConfig.data));
    // open the popup and get a reference to it called dialogRef
    // const dialogRef = this.dialog.open(RateLosComponent, dialogConfig);

  }


  updateRowsWithSameRateDetailId(rateBucketDetailId: number)
  {

    // form to submit to the server
    let searchForm: any = {};

    // list of strs we will search for to replace in current array due to update
    let selectedShortTermRentalIds = [];

    // to hold for success message
    let selectedPropertyCodes = [];

    // for each existing property in all our rates
    for (let index = 0; index < this.advertisedRates.length; index++)
    {
      const element = this.advertisedRates[index][0];

      // if the existing property has the same rateBucketDetailId as the one we just changed
      if (element.rateBucketDetailId && element.rateBucketDetailId === rateBucketDetailId)
      {
        // store the propertyId into the search form
        selectedShortTermRentalIds.push(element.propertyId);
        selectedPropertyCodes.push('<b>' + element.propertyCode + '</b><br>');
      }
    }

    // finalize the search form
    searchForm.shortTermRentalIdList = selectedShortTermRentalIds;
    searchForm.startDate = this.currentSearchForm.startDate;
    searchForm.endDate = this.currentSearchForm.endDate;
    // console.log('my search is ' + JSON.stringify(searchForm));

    this.getAdvertisedRatesToSpliceIntoResult(searchForm, selectedPropertyCodes);


  }


  onSearchSubmit(searchForm: any)
  {
    // clear stale column filters from previous search
    if (this.dt) {
      this.dt.reset();
    }
    // kill the old transformation
    this.advertisedRateRows = [];
    this.frozenColumns = [];

    // store the search
    this.currentSearchForm = searchForm;
    if(this.sortingColDate != null && this.sortingState != null && this.selectedSortField != null)
    {
      const sortOrder = this.sortingState[this.sortingColDate];
      if (sortOrder) {
        searchForm['sortSeasongByStartDate'] = this.sortingColDate;
        searchForm['sortSeasonByOrder'] = sortOrder;
        searchForm['sortSeasonByField'] = this.selectedSortField;
      }
    }
    this.getRatesForNewSearch(searchForm);
  }

  // https://stackoverflow.com/questions/59878134/primeng-table-filtering-and-sorting-on-each-column-doesnt-work
  // everytime you click in filter it just resorts.
  clickOnFilter(event: Event)
  {
    event.stopPropagation();
  }

  // when we change the rateBucketAdjusterPct
  onRateBucketAdjusterPctChange(propertyId: number, newRrateBucketAdjusterPct: number, rowData: any)
  {
    let itemIndex = this.advertisedRateRows.findIndex(advertisedRate => advertisedRate[0].propertyId === propertyId);
    // Object.keys(this.advertisedRateRows[itemIndex]).forEach(e => console.log('key=' + e + ' value=' + JSON.stringify(this.advertisedRateRows[itemIndex][e])));

    Object.keys(this.advertisedRateRows[itemIndex]).forEach(e =>
    {
      if (this.advertisedRateRows[itemIndex][e] && this.advertisedRateRows[itemIndex][e].rateBucketAdjusterPct !== undefined)
      {
        this.advertisedRateRows[itemIndex][e].rateBucketAdjusterPct = newRrateBucketAdjusterPct;
      }
    });

    this.advertisedRateRows[itemIndex].rateBucketAdjusterPct = newRrateBucketAdjusterPct;
  }

  onListPriceChange(rateBucketDetailId: number, newListPriceAdjustmentAmount: number)
  {

    for (let [key, value] of Object.entries(this.advertisedRateRows))
    {
      // console.log(`${key}: ${JSON.stringify(value)}`);
      Object.keys(this.advertisedRateRows[key]).forEach(e =>
      {
        if (this.advertisedRateRows[key][e] && this.advertisedRateRows[key][e].listPrice !== undefined && this.advertisedRateRows[key][e].rateBucketDetailId === rateBucketDetailId)
        {
          this.advertisedRateRows[key][e].listPriceAdjustmentAmount = +newListPriceAdjustmentAmount;
        }
      });
    }
  }

  incRateBucketAdjPct(propertyId: number, newRrateBucketAdjusterPct: number, rowData: any)
  {
    newRrateBucketAdjusterPct = +newRrateBucketAdjusterPct;
    this.onRateBucketAdjusterPctChange(propertyId, ((!newRrateBucketAdjusterPct || newRrateBucketAdjusterPct === 0) ? 0.00 : newRrateBucketAdjusterPct) + .01, rowData);
    // this.calcYearlyGrossRev(rowData);
  }

  decRateBucketAdjPct(propertyId: number, newRrateBucketAdjusterPct: number, rowData: any)
  {
    newRrateBucketAdjusterPct = +newRrateBucketAdjusterPct;
    this.onRateBucketAdjusterPctChange(propertyId, ((!newRrateBucketAdjusterPct || newRrateBucketAdjusterPct === 0) ? 0.00 : newRrateBucketAdjusterPct) - .01, rowData);
    // this.calcYearlyGrossRev(rowData);
  }

  incListPrice(rateBucketDetailId: number, newListPriceAdjustmentAmount: number)
  {
    newListPriceAdjustmentAmount = +newListPriceAdjustmentAmount;
    this.onListPriceChange(rateBucketDetailId, ((!newListPriceAdjustmentAmount || newListPriceAdjustmentAmount === 0) ? 0.00 : newListPriceAdjustmentAmount) + 10.00);
    // this.calcYearlyGrossRev(rowData);
  }

  decListPrice(rateBucketDetailId: number, newListPriceAdjustmentAmount: number)
  {
    newListPriceAdjustmentAmount = +newListPriceAdjustmentAmount;
    this.onListPriceChange(rateBucketDetailId, ((!newListPriceAdjustmentAmount || newListPriceAdjustmentAmount === 0) ? 0.00 : newListPriceAdjustmentAmount) - 10.00);
    // this.calcYearlyGrossRev(rowData);
  }

  formatPercent(numPercent: string)
  {
    return parseFloat(numPercent).toFixed(2);
  }

  onRateBucketAdjusterPctSave(propertyId: number, newRateBucketAdjusterPct: number)
  {
    let rateSummary: any = {};
    rateSummary.propertyId = propertyId;
    rateSummary.rateBucketAdjusterPct = newRateBucketAdjusterPct;
    console.log('saving: ' + propertyId + ' with new value ' + newRateBucketAdjusterPct + ' object ' + JSON.stringify(rateSummary));
    this.updateRateSummary(rateSummary);
  }

  onRateBucketListPriceSave(rateBucketId: number, newListPriceAdjustmentAmount: number)
  {
    let rateSummary: any = {};
    rateSummary.rateBucketId = rateBucketId;
    rateSummary.listPriceAdjustmentAmount = newListPriceAdjustmentAmount;
    // console.log('saving: ' + rateBucketId + ' with new value ' + newListPrice + ' object ' + JSON.stringify(rateSummary));
    this.updateRateSummary(rateSummary);
  }

  updateRateSummary(rateSummary: any)
  {

    this.formLoading = false;
    this.rateSeasonSummaryService.updateRateSummary(rateSummary)
      .subscribe(
        res =>
        {
          // console.log('searchRateSummaries SUCCESS: ' + JSON.stringify(res.data.rateSummary));
          // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Season updated successfully. Rates are being generated in background.', life: 3000 });
          this.cdr.markForCheck();
        },
        err =>
        {
          console.log('updateRateSummary FAIL: ' + JSON.stringify(err));
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
          this.cdr.markForCheck();
        },
        () => { this.formLoading = false; this.cdr.markForCheck(); });
  }

  calcListPrice(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPrice)
    {
      return +this.formatPercent(advertisedRate.listPrice);
    }
  }

  calcListPriceAdj(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPrice)
    {
      if(advertisedRate.listPriceAdjustmentAmount != null)
        return +this.formatPercent(advertisedRate.listPriceAdjustmentAmount);
      else
        return +this.formatPercent(advertisedRate.listPrice);
    }
  }

  calcPropertyListPrice(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.rateBucketAdjusterPct)
    {
      return this.calcListPriceAdj(advertisedRate) + (this.calcListPriceAdj(advertisedRate) * advertisedRate.rateBucketAdjusterPct)
    }
    else
    {
      return this.calcListPriceAdj(advertisedRate);
    }
  }

  isNaN(value: any): boolean {
    return Number.isNaN(value);
  }

  calcSeasonExpectedRevanue(advertisedRate: any)
  {
    let listPrice = 0;
    if (advertisedRate && advertisedRate.rateBucketAdjusterPct)
      {
        listPrice = this.calcListPrice(advertisedRate) + (this.calcListPrice(advertisedRate) * advertisedRate.rateBucketAdjusterPct)
      }
      else
      {
        listPrice = this.calcListPrice(advertisedRate);
      }
    return listPrice * advertisedRate.daysInSeasonTTL * advertisedRate.seasonOccupancy;
  }

  calcSeasonAchivedRevanuePct(advertisedRate: any)
  {
    let expectedRevanue = this.calcSeasonExpectedRevanue(advertisedRate);
    return advertisedRate.nightlyRateTTL / expectedRevanue;
  }


  calcYMDiscFloorPrice(advertisedRate: any)
  {
    // if we have a discounting algorithm
    if (advertisedRate && advertisedRate.discountLookForwardDays && advertisedRate.discountLookForwardDays > 0 && advertisedRate.discountMaxPercent != null)
    {
      let floor = 0.00;

      // calculate the lowest by the yield manager
      floor = +this.calcPropertyListPrice(advertisedRate) + (+this.calcPropertyListPrice(advertisedRate) * advertisedRate.discountMaxPercent);

      if (advertisedRate.minimumPriceSetByManager && advertisedRate.minimumPriceSetByManager > 0)
      {
        if (floor > advertisedRate.minimumPriceSetByManager)
        {
          return floor;
        }
        else
        {
          return advertisedRate.minimumPriceSetByManager
        }
      }
      else if (advertisedRate.minimumPriceSetByOwner && advertisedRate.minimumPriceSetByOwner > 0)
      {
        if (floor > advertisedRate.minimumPriceSetByOwner)
        {
          return floor;
        }
        else
        {
          return advertisedRate.minimumPriceSetByOwner
        }
      }
      else
      {
        return floor;
      }
    }
    else
    {
      return +this.calcPropertyListPrice(advertisedRate);
    }
  }

  calcMinListPrice(advertisedRate: any)
  {

    let response: any = {};
    let systemFloorRate = [];
    let rates = [];

    /*
    Calc the lowest allowed rate, if any set by manager, owner, or global
    */

    // calc lowest by Manager
    systemFloorRate.push(advertisedRate.minimumPriceSetByManager ? advertisedRate.minimumPriceSetByManager : 0);

    // calc lowest by Owner
    systemFloorRate.push(advertisedRate.minimumPriceSetByOwner ? advertisedRate.minimumPriceSetByOwner : 0);

    // calc lowest by global minNightly
    systemFloorRate.push(advertisedRate.minNightlyRate ? advertisedRate.minNightlyRate : 0);

    // calc lowest by rack or discounter
    let minAdRate = (this.calcPropertyListPrice(advertisedRate) +
      (+this.calcPropertyListPrice(advertisedRate) * (advertisedRate.discountMaxPercent ? advertisedRate.discountMaxPercent : 0)));


    let minSystemRate = Math.max(...systemFloorRate);


    // if we have a artificially high floor,
    if (minSystemRate > minAdRate)
    {
      response.rate = minSystemRate;
      response.color = '#FFA500';
    }
    else
    {
      response.rate = minSystemRate;
      response.color = 'transparent';
    }

    return response;

  }
  // calcListPriceAdjPct(advertisedRate: any)
  // {
  //   if (advertisedRate && advertisedRate.listPriceAdjustmentPercent)
  //   {
  //     let propertyListPrice = +this.calcPropertyListPrice(advertisedRate);
  //     return propertyListPrice + (propertyListPrice * advertisedRate.listPriceAdjustmentPercent)
  //   }
  // }
  // calcYearlyGrossRev(rowData: any)
  // {
  //   let yearlyRevSummary: any = {};

  //   let yrListPrice = 0;
  //   let yrListPriceAdj = 0;
  //   let yrPropertyListPrice = 0;
  //   let yrYMDiscFloorPrice = 0;

  //   // if its an object of the rateBucketDetail
  //   if (rowData[0] && rowData[0] !== undefined && rowData[0].startDate !== undefined)
  //   {

  //     // get the date of the first rateBucketDetail
  //     let thisCalendarYear = new Date(rowData[0].startDate);

  //     Object.keys(rowData).forEach(e =>
  //     {
  //       if (rowData[e] && rowData[e].listPrice !== undefined)
  //       {

  //         let startDate: Date = new Date(rowData[e].startDate)

  //         if (startDate.getFullYear() === thisCalendarYear.getFullYear())
  //         {
  //           let seasonOccupancy = (+rowData[e].seasonOccupancy);
  //           let endDate: Date = new Date(rowData[e].endDate)

  //           yrListPrice = yrListPrice + (this.calcListPrice(rowData[e]) * (1 + (endDate.getTime() - startDate.getTime()) / this.dayMs) * seasonOccupancy);
  //           yrPropertyListPrice = yrPropertyListPrice + (this.calcPropertyListPrice(rowData[e]) * (1 + (endDate.getTime() - startDate.getTime()) / this.dayMs) * seasonOccupancy);
  //           yrYMDiscFloorPrice = yrYMDiscFloorPrice + (this.calcYMDiscFloorPrice(rowData[e]) * (1 + (endDate.getTime() - startDate.getTime()) / this.dayMs) * seasonOccupancy);
  //           yrListPriceAdj = yrListPriceAdj + (this.calcListPriceAdjPct(rowData[e]) * (1 + (endDate.getTime() - startDate.getTime()) / this.dayMs) * seasonOccupancy);
  //         }
  //       }
  //     });
  //   }
  //   yearlyRevSummary.yrListPrice = yrListPrice;
  //   yearlyRevSummary.yrListPriceAdj = yrListPriceAdj;
  //   yearlyRevSummary.yrPropertyListPrice = yrPropertyListPrice;
  //   yearlyRevSummary.yrYMDiscFloorPrice = yrYMDiscFloorPrice;

  //   return yearlyRevSummary;
  // }

  get totalProperties(): number {
    if (!this.advertisedRateRows || this.advertisedRateRows.length === 0) return 0;
    return new Set(this.advertisedRateRows.map((r: any) => r.propertyCode)).size;
  }

  @HostListener('window:resize')
  onResize() {
    this.setInnerWidthHeightParameters();
  }

  setInnerWidthHeightParameters()
  {
    this.innerWidth = window.innerWidth;
    // KBM top nav (~90px) + sub-tabs (~45px) + 1-row search (~52px)
    // + "Showing X" label (~22px) + table header (~48px) + scrollbar buffer (~20px)
    this.innerHeight = window.innerHeight - 277;
    if (this.innerWidth < 768) { this.frozenWidth = '150px'; }
    else if (this.innerWidth < 992) { this.frozenWidth = '250px'; }
    else { this.frozenWidth = '400px'; }
  }
  openCm(event, cm, rowNode) {
    event.preventDefault();
    event.stopPropagation();
    if(this.selectedNode != null 
      && this.selectedNode.rateBucketDetailId == rowNode.rateBucketDetailId)
    {
      cm.toggle(event);
    }
    else
    {
      cm.show(event);
    }
    this.selectedNode = rowNode;
    return false;
  }

  onRowSelect(data) {
		try {
			const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = true;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "100vw";
		dialogConfig.width = "90vw";
		dialogConfig.height = "45vw";
		dialogConfig.maxHeight = "60vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyId: data.propertyId,
			rateBucketId: data.rateBucketId,
			propertyCode: data.propertyCode,
			title: 'Property Configuration'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyConfigComponent, dialogConfig);
		} catch (error) {
			console.log('onRowSelect(' + event + ')' + error);
		}
	}

}
